.table th {
  text-transform: none;
  letter-spacing: normal;
}
